import VueLoader from '../../vue-loader'

import Expand from './expand.js'
import F1Tv from './f1_tv'
import FanaticCodes from './fanatic_codes'
import CancellationForm from './cancellation_form'
import LineItems from './line_items'
import MementoCodes from './memento_codes'
import PaymentTermsList from '../payment_terms/list_no_charge'
import PaymentTermsListChargeable from '../payment_terms/list_chargeable'
import RoomingLists from './rooming_lists'
import ShipmentCode from './shipment_code'

document.addEventListener('turbolinks:load', () => {
  Expand.addOpenCloseClasses()
  VueLoader.loadVueComponent(PaymentTermsListChargeable,
    document.getElementById('opportunityPaymentTermsToCharge'))
  VueLoader.loadVueComponent(PaymentTermsList,
    document.getElementById('opportunityPaymentTermsBasicInfo'))

  VueLoader.loadVueComponent(RoomingLists, document.getElementById('opportunityRoomingList'))

  VueLoader.loadVueComponent(CancellationForm, document.getElementById('opportunityCancellation'))
  VueLoader.loadVueComponent(LineItems, document.getElementById('opportunityLineItems'))

  VueLoader.loadVueComponent(F1Tv, document.getElementById('opportunityF1TvCode'))
  VueLoader.loadVueComponent(FanaticCodes, document.getElementById('opportunityFanaticCode'))
  VueLoader.loadVueComponent(ShipmentCode, document.getElementById('opportunityShipmentCode'))
  VueLoader.loadVueComponent(MementoCodes, document.getElementById('opportunityMementoCode'))
})

export default {}
